module.exports = __webpack_public_path__ + "media/images/empresa/emp_cred2-6afd67130c114c9779d0d1a94b66e72d.svg";